import { render, staticRenderFns } from "./SearchText.vue?vue&type=template&id=842284be&"
import script from "./SearchText.vue?vue&type=script&lang=ts&"
export * from "./SearchText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports